import React, { useCallback, useState } from 'react';

import { MainSidebarContext } from './MainSidebarContext';

export function MainSidebarProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpenState] = useState(() => {
    // Try to get from localStorage first
    const stored = localStorage.getItem('main-sidebar-open');
    return stored !== null ? stored === 'true' : true;
  });

  const setIsOpen = useCallback((open: boolean) => {
    setIsOpenState(open);
    localStorage.setItem('main-sidebar-open', open.toString());
  }, []);

  const toggle = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen]);

  return (
    <MainSidebarContext value={{ isOpen, setIsOpen, toggle }}>
      {children}
    </MainSidebarContext>
  );
}
